<div class="tracker-main padding_top0 vh-100start">
    <div class="container start-container">
        <div class="row align-items-center">
            <div class="col-sm-12">
                <div class="card py-5 p-3 border-0">


                <div class="row align-items-center">
                    <div class="col-sm-6 left-part mobileLogo">
                        <app-brand-image></app-brand-image>
                    </div>
                    <div class="col-sm-6">
                        <div class="left-part">
                            <em class="icon-icn-car-config font100 text-primary"></em>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="right-part">
                            <label translate>lblWelcome <strong class="font16">{{customerDetail?.customerName}}</strong></label>
                            <div class="loginlp mb-3">
                                <div [ngClass]="licensePlateClass" class="licence-pl mb-0">
                                    <input type="text" class="center" value="{{vehicleDetail?.licensePlateNumber}}"
                                        readonly />
                                </div>
                                <span class="webLogo">
                                    <app-brand-image></app-brand-image>
                                </span>
                            </div>
                            <a href="javascript:void(0);" class="btn btn-primary minwidth btn-lg"
                                (click)="moveNext()" translate>lblNext</a>
                        </div>
                    </div>
                </div>
                </div>

            </div>

        </div>
    </div>
</div>
<app-footer-site-info></app-footer-site-info>